export const login: () => Promise<{ name: string }> = async () => {
  // eslint-disable-next-line no-console
  console.log('Logging in')
  return Promise.resolve({ name: 'user' })
}
